import { createSlice } from '@reduxjs/toolkit'
// import { tableData } from '../../data/data';
// import { results } from '../../data/results';

export const visualSlice = createSlice({
  name: 'visual',
  initialState: {
    results: [],
    tableInfo: {},
    metricsTable: {},
    tableData: {},
    chatMessages: [],
    menuEnabled: "home",
    activeResultIndex: -1,
    xColumn: {},
    dataColumns: [],
    activeTabIndex: 0,
    activeTabTitle: "",
    databases: [],
    activeDbIndex: -1,
    activeDbName: "",
    activeTableIndex: -1,
    activeTableName: "",
    currentTableData: {},
    securityKey: "",
  },
  reducers: {
    addChatMessages: (state, action) => {
      state.chatMessages = [...state.chatMessages, action.payload];
    },
    setMenuEnabled: (state, action) => {
      console.log(action.payload);
      state.menuEnabled = action.payload;
    },
    setTableInfo: (state, action) => {
      state.tableInfo = action.payload;
    },
    setMetricsTable: (state, action) => {
      state.metricsTable = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    addResult: (state,action) => {
      console.log(action.payload);
      state.results = [...state.results,action.payload];
      state.activeResultIndex = state.results.length-1;
      state.activeTabIndex = state.results.length-1;
      console.log(state.results);
    },
    addChart: (state,action) => {
      console.log(action);
      const chartType = action.payload;
      if(chartType === 'Line Chart'){
        console.log(state.results);
        const currentCharts = JSON.parse(JSON.stringify(state.results[state.activeResultIndex].charts));
        console.log(currentCharts);
        const newCharts = [...currentCharts];
        newCharts.push(
        {
            chartType: chartType,
            chartData: {'xColumn': state.xColumn, 'dataColumns': state.dataColumns}
        });
        state.activeTabIndex = newCharts.length;
        const newResults = [...state.results];
        newResults[state.activeResultIndex].charts = newCharts;
        state.results = newResults;
        state.dataColumns = [];
        console.log(state.results);
      }
      
    },
    setActiveResultIndex: (state,action) => {
      console.log(action);
      const newActiveResultIndex = action.payload;
      state.activeResultIndex = newActiveResultIndex;
    },
    setXColumn: (state,action) => {
      state.xColumn = action.payload;
    },
    emptyDataColumns: (state,action) => {
      state.dataColumns = [];
    },
    addDataColumns: (state,action) => {
      const newColumn = action.payload;
      state.dataColumns = [...state.dataColumns, newColumn];
    },
    setActiveTabIndex: (state,action) => {
      const index = action.payload;
      state.activeTabIndex = index;
    },
    setActiveTabTitle: (state,action) => {
      state.activeTabTitle = action.payload;
    },
    setDatabase: (state,action) => {
      console.log(action.payload);
      state.databases = action.payload;
    },
    performTransformation: (state,action) => {
      const newTableData = action.payload;
      const newResults = [...state.results];
      newResults[state.activeResultIndex].tableData = newTableData;
      state.results = newResults;
      console.log(JSON.parse(JSON.stringify(state.currentTableData)));
      console.log(action.payload);
      state.currentTableData = newTableData;
      console.log(JSON.parse(JSON.stringify(state.currentTableData)));
    },
    setActiveDbName: (state, action ) => {
      state.activeDbName =action.payload;
    },
    setSecurityKey: (state, action) => {
      state.securityKey = action.payload;
    }
  },
})

export const {addChatMessages, setMenuEnabled, setTableInfo, setMetricsTable, addResult, addChart, setActiveResultIndex, setXColumn, 
  addDataColumns, setActiveTabIndex, setActiveTabTitle, setDatabase, performTransformation, setActiveDbName, setTableData, setSecurityKey } = visualSlice.actions

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
// export const incrementAsync = (amount) => (dispatch) => {
//   setTimeout(() => {
//     dispatch(incrementByAmount(amount))
//   }, 1000)
// }

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`

export const getMenuEnabled = (state) => {
  return state.visual.menuEnabled;
}

export const selectResults = (state) => {
  return state.visual.results;
}

export const selectActiveResultIndex = (state) => {
  return state.visual.activeResultIndex;
}

export const getXColumn = (state) => {
  return state.visual.xColumn;
}

export const getDataColumns = (state) => {
  return state.visual.dataColumns;
}

export const getActiveTabIndex = (state) => {
  return state.visual.activeTabIndex;
}

export const getActiveTabTitle = (state) => {
  return state.visual.activeTabTitle;
}

export const getDatabases = (state) => {
  return state.visual.databases;
}

// export const getTableData = (state) => {
//   console.log(state.visual.currentTableData);
//   return state.visual.currentTableData;
// }

export const getActiveDbName = (state) => {
  return state.visual.activeDbName;
}

export const getTableInfo = (state) => {
  return state.visual.tableInfo;
}

export const getMetricsTable = (state) => {
  return state.visual.metricsTable;
}

export const getTableData = (state) => {
  return state.visual.tableData;
}


export const getSecurityKey = (state) => {
  return state.visual.securityKey;
}

export const getChatMessgaes = (state) => {
  return state.visual.chatMessages;
}
export default visualSlice.reducer
